export default __webpack_public_path__ + "static/media/Imagem Main Content-3.bb9bff17.png";